/*
 * LICENSE PROTECTED SOFTWARE
 *
 * Bu yazilim lisans korumasi altindadir.
 * Gecerli lisans olmadan kullanilmasi yasaktir.
 *
 * Kaynak kodunun izinsiz erisimi, kopyalanmasi veya dagitimi
 * hukuki yaptirimslara tabidir.
 * (c) 2026  @cemdemirci0101
 *  bilgi@cemdemirci.com
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution
 * of this file, via any medium, is strictly prohibited.
 * (c) 2026 All Rights Reserved.
 */

import React from 'react';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Mail, ChevronDown, ChevronUp } from 'lucide-react';
import { TARGET_AUDIENCES } from '../lib/utils';

/**
 * E-posta bildirim toggle + hedef kitle secimi
 * Her oluşturma formuna eklenir (Duyuru, Toplanti, Etkinlik, Anket)
 */
export default function EmailNotifyToggle({
  sendEmail, setSendEmail,
  emailAudiences, setEmailAudiences,
  defaultAudiences = [],
}) {
  const [expanded, setExpanded] = React.useState(false);

  const toggleAudience = (val) => {
    if (val === 'tum_kullanicilar') {
      setEmailAudiences(['tum_kullanicilar']);
      return;
    }
    const filtered = (emailAudiences || []).filter(a => a !== 'tum_kullanicilar');
    if (filtered.includes(val)) {
      setEmailAudiences(filtered.filter(a => a !== val));
    } else {
      setEmailAudiences([...filtered, val]);
    }
  };

  return (
    <div className="border border-slate-200 rounded-lg p-3 bg-slate-50/50" data-testid="email-notify-section">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Mail className="w-4 h-4 text-blue-600" />
          <Label className="text-sm font-medium text-slate-700 cursor-pointer" onClick={() => setSendEmail(!sendEmail)}>
            Kullanicilara E-posta Gonder
          </Label>
        </div>
        <button
          type="button"
          onClick={() => setSendEmail(!sendEmail)}
          className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${sendEmail ? 'bg-blue-600' : 'bg-slate-300'}`}
          data-testid="email-toggle"
        >
          <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${sendEmail ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} />
        </button>
      </div>

      {sendEmail && (
        <div className="mt-3 space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-xs text-slate-500">Hedef Kitle</Label>
            <button type="button" onClick={() => setExpanded(!expanded)} className="text-xs text-blue-600 flex items-center gap-0.5">
              {expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
              {expanded ? 'Gizle' : 'Ozelestir'}
            </button>
          </div>

          {!expanded ? (
            <div className="flex flex-wrap gap-1">
              {(emailAudiences || defaultAudiences || ['tum_kullanicilar']).map(a => {
                const t = TARGET_AUDIENCES.find(ta => ta.value === a);
                return <Badge key={a} variant="outline" className="text-[10px]">{t?.label || a}</Badge>;
              })}
              <span className="text-[10px] text-slate-400 self-center ml-1">(Icerigin hedef kitlesi)</span>
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-1.5">
              {TARGET_AUDIENCES.map(ta => {
                const selected = (emailAudiences || []).includes(ta.value);
                return (
                  <button
                    key={ta.value} type="button"
                    onClick={() => toggleAudience(ta.value)}
                    className={`text-left text-xs px-2.5 py-1.5 rounded border transition-colors ${selected ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'}`}
                    data-testid={`audience-${ta.value}`}
                  >
                    {ta.label}
                  </button>
                );
              })}
            </div>
          )}

          <p className="text-[10px] text-slate-400">Sadece e-posta iletisim izni veren kullanicilara gonderilir.</p>
        </div>
      )}
    </div>
  );
}
